module.exports = __webpack_public_path__ + "img/but.9cea8a3d.png";